export default "__VITE_ASSET__DvlnWdDq__"